import ApiService from "@/services/apiservice";

function generateErrorMessage() {
    const errorMessages = [
        {title: "ERROR_MESSAGE_1_TITLE", message:"ERROR_MESSAGE_1_BODY"},
        {title: "ERROR_MESSAGE_2_TITLE", message:"ERROR_MESSAGE_2_BODY"},
        {title: "ERROR_MESSAGE_3_TITLE", message:"ERROR_MESSAGE_3_BODY"},
        {title: "ERROR_MESSAGE_4_TITLE", message:"ERROR_MESSAGE_4_BODY"},
        {title: "ERROR_MESSAGE_5_TITLE", message:"ERROR_MESSAGE_5_BODY"},
        {title: "ERROR_MESSAGE_6_TITLE", message:"ERROR_MESSAGE_6_BODY"},
        {title: "ERROR_MESSAGE_7_TITLE", message:"ERROR_MESSAGE_7_BODY"},
        {title: "ERROR_MESSAGE_8_TITLE", message:"ERROR_MESSAGE_8_BODY"},
        {title: "ERROR_MESSAGE_9_TITLE", message:"ERROR_MESSAGE_9_BODY"},
        {title: "ERROR_MESSAGE_10_TITLE", message:"ERROR_MESSAGE_10_BODY"},
    ]

    const randomIndex = Math.floor(Math.random() * errorMessages.length);

    return errorMessages[randomIndex];
}

const apiPlugin = (store) => {
    
    store.apiService = ApiService;

    store.makeRequest = async function({ reqFunc, payload }) {
        
        try {
            let result;
            
            if (payload !== undefined) {
                result = await reqFunc(payload);
            } else {
                result = await reqFunc();
            }

            if (!result.data || !result.data.status) {
                await store.dispatch('showError', generateErrorMessage());       
                return false;
            }

            return result;
            
        } catch (err) {
            console.error("error making request: ", err);
            await store.dispatch('showError', generateErrorMessage());
            return false;
        }
    }
}

export default apiPlugin;